var React = require('react');

function EyeView (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33 23.993a8.996 8.996 0 00-9-8.995 9 9 0 109 9.001v-.006zm-9-5.995a5.997 5.997 0 016 5.997v.004a6 6 0 11-6-6.001z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M46.758 20.76C41.398 14.869 32.688 8.868 24 9.003c-8.689-.135-17.398 5.866-22.752 11.76l-.005.004a4.825 4.825 0 000 6.46l.004.004C6.481 32.995 15.167 39.133 24 38.996c8.832.137 17.52-6.001 22.758-11.765l.005-.005a4.825 4.825 0 000-6.46l-.005-.005zM3.47 25.217a1.825 1.825 0 010-2.44c5.125-5.64 13.078-10.9 20.504-10.774h.05c7.426-.126 15.38 5.134 20.51 10.774a1.825 1.825 0 010 2.44c-5.021 5.525-12.952 10.907-20.51 10.78h-.05c-7.558.127-15.487-5.255-20.504-10.78z","key":1})]);
}

EyeView.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = EyeView;

EyeView.default = EyeView;
